export default __webpack_public_path__ + "static/media/uploadIconBlack.8ef81760.svg";